import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Typography from './Typography';
import ChevronDownIcon from './Icons/ChevronDownIcon';
import Button from '../components/Button/Button';
import { theme } from '../theme';

const HistoryDropdown = ({ value, onChange }) => {
  const { t } = useTranslation('agenda');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const historyOptions = [
    { value: 'upcoming', label: t('filters.history.upcoming', 'Eventos próximos') },
    { value: 'past', label: t('filters.history.past', 'Eventos pasados') }
  ];

  const selectedOption = historyOptions.find(option => option.value === value) || historyOptions[0];

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <DropdownContainer ref={dropdownRef}>
      <DropdownButton onClick={handleToggle} $isOpen={isOpen}
        $variant="outline"
        size="l"
        sizeTablet="l"
        sizeMobile="m"
      >
        <Typography $variant="body-2-medium" color={theme.colors.defaultMain}>
          {selectedOption.label}
        </Typography>
        <ChevronIcon $isOpen={isOpen}>
          <ChevronDownIcon fill={theme.colors.defaultMain} width={16} height={16} />
        </ChevronIcon>
      </DropdownButton>

      {isOpen && (
        <DropdownMenu>
          {historyOptions.map(option => (
            <DropdownItem
              key={option.value}
              onClick={() => handleSelect(option.value)}
              $isSelected={option.value === value}
            >
              <Typography
                $variant="body-2-medium"
                color={option.value === value ? theme.colors.brandMain : theme.colors.defaultMain}
              >
                {option.label}
              </Typography>
            </DropdownItem>
          ))}
        </DropdownMenu>
      )}
    </DropdownContainer>
  );
};

export default HistoryDropdown;

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownButton = styled(Button)`
  min-width: 170px;
  justify-content: space-between;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    min-width: 150px;
  }
`;

// const DropdownButton = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   width: 100%;
//   padding: 8px 12px;
//   background: ${({ theme }) => theme.fill.defaultMain};
//   border: 1px solid ${({ theme, $isOpen }) => $isOpen ? theme.border.brandMain : theme.border.defaultWeak};
//   border-radius: ${({ theme }) => theme.radius.xs};
//   cursor: pointer;
//   transition: all 0.2s ease;

//   &:hover {
//     background: ${({ theme }) => theme.fill.defaultWeak};
//     border-color: ${({ theme }) => theme.border.defaultMain};
//   }

//   &:focus {
//     outline: none;
//     border-color: ${({ theme }) => theme.border.brandMain};
//     box-shadow: 0 0 0 2px ${({ theme }) => theme.border.brandWeak};
//   }
// `;

const ChevronIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  transform: ${({ $isOpen }) => $isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  margin-left: ${({ theme }) => theme.sizing.xs};
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background: ${({ theme }) => theme.fill.defaultMain};
  border: 1px solid ${({ theme }) => theme.border.defaultWeak};
  border-radius: ${({ theme }) => theme.radius.xs};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 4px;
  overflow: hidden;
`;

const DropdownItem = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 12px;
  background: ${({ theme, $isSelected }) => $isSelected ? theme.fill.brandWeak : 'transparent'};
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${({ theme, $isSelected }) => $isSelected ? theme.fill.brandWeak : theme.fill.defaultWeak};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  }
`;